import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { DuplicateIcon } from 'foundations-assets';
import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import FormattedPropertyV2 from 'customer-data-properties/formatted/FormattedPropertyV2';
import getPropertyValue from '../dataAccessHelpers/getPropertyValue';
import getPropertyLabel from '../dataAccessHelpers/getPropertyLabel';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import getPropertyDefinition from '../dataAccessHelpers/getPropertyDefinition';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PaymentMethodFormatter from '../customFormatters/PaymentMethodFormatter';
import StyledProperty from './stylingComponents/StyledProperty';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PaymentProperties = ({
  objectId,
  properties,
  isAccountEnabled
}) => {
  const customerEmail = getPropertyValue(properties, 'hs_customer_email');
  const initiatedDate = getPropertyValue(properties, 'hs_initiated_date');
  const paymentCreationMethod = getPropertyValue(properties, 'hs_payment_creation_method');
  const processorTypeValue = getPropertyValue(properties, 'hs_processor_type');
  const paymentMethodTypeValue = getPropertyValue(properties, 'hs_payment_method_type');
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(StyledProperty, {
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "cardPaymentHighlight.paymentHighlight.initiatedDate",
        options: {
          paymentDateLabel: getPropertyLabel(properties, 'hs_initiated_date'),
          formattedDate: /*#__PURE__*/_jsx(FormattedPropertyV2, {
            objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
            objectId: objectId,
            dateTimeFormat: "lll",
            property: getPropertyDefinition(properties, 'hs_initiated_date'),
            value: initiatedDate,
            getAdditionalPropertyValue: propertyName => getPropertyValue(properties, propertyName)
          })
        }
      })
    }), customerEmail && /*#__PURE__*/_jsxs(StyledProperty, {
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "cardPaymentHighlight.paymentHighlight.customer",
        options: {
          customerLabel: getPropertyLabel(properties, 'hs_customer_email'),
          customerEmail
        }
      }), /*#__PURE__*/_jsx(CopyButton, {
        hintSuccess: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.copyButtonSuccess"
        }),
        tooltipPlacement: "right",
        use: "link",
        value: customerEmail,
        paddingInlineStart: "100",
        children: /*#__PURE__*/_jsx(DuplicateIcon, {})
      })]
    }), paymentMethodTypeValue && /*#__PURE__*/_jsx(StyledProperty, {
      children: /*#__PURE__*/_jsx(PaymentMethodFormatter, {
        objectId: objectId,
        propertyDefinition: getPropertyDefinition(properties, 'hs_payment_method_type'),
        paymentCreationMethod: paymentCreationMethod,
        paymentMethodType: paymentMethodTypeValue,
        referenceNumber: getPropertyValue(properties, 'hs_reference_number'),
        last4: getPropertyValue(properties, 'hs_payment_method_last_4'),
        bankOrIssuer: getPropertyValue(properties, 'hs_payment_method_bank_or_issuer')
      })
    }), /*#__PURE__*/_jsxs(StyledProperty, {
      children: [/*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "cardPaymentHighlight.paymentHighlight.processorType",
        options: {
          processorLabel: getPropertyLabel(properties, 'hs_processor_type'),
          processorValue: /*#__PURE__*/_jsx(FormattedPropertyV2, {
            objectTypeId: COMMERCE_PAYMENT_TYPE_ID,
            objectId: objectId,
            property: getPropertyDefinition(properties, 'hs_processor_type'),
            value: processorTypeValue,
            getAdditionalPropertyValue: propertyName => getPropertyValue(properties, propertyName)
          })
        }
      }), !isAccountEnabled && (processorTypeValue === 'hs_payments' || processorTypeValue === 'byo_stripe') && /*#__PURE__*/_jsx(Badge, {
        marginInlineStart: "200",
        use: "candy-apple",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cardPaymentHighlight.paymentHighlight.disconnectedBadge"
        })
      })]
    })]
  });
};
export default PaymentProperties;